import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-formula-sheets-banner-card',
  templateUrl: './formula-sheets-banner-card.component.html',
  styleUrls: ['./formula-sheets-banner-card.component.css']
})
export class FormulaSheetsBannerCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
